import Scene = Phaser.Scene;
import {BasePanel} from "@/scenes.ui/base-panel";
import {injectable} from "inversify";
import MiniCreaturesPanel from "@/scenes.ui/mini-creatures-panel";
import {Creature} from "@/store/level/types";
import {CreatureUtils} from "@/utils/creature-utils";
import {Sizes} from "@/constants/size";
import {Artifact} from "@/store/artifact/types";
import {ArtifactSlot} from "@/scenes.ui/artifact-slot";
import {AbstractCreatureService} from "@/services/abstract-creature-service";
import ArtifactUtils from "@/utils/artifact-utils";
import PlayerStore from "@/store/player";
import {BottomForcesPanel} from "@/scenes.ui/bottom-forces-panel";

@injectable()
export class EnemyCreatureService extends AbstractCreatureService {

    private creatures!: Creature[];

    public initEnemyCreatureService(scene: Scene, canvas: HTMLCanvasElement, creatureIndex: number, backCallback: () => unknown, creatures: Creature[]) {
        super.initPage(scene, canvas, creatureIndex, backCallback);

        this.creatures = creatures;

        this.setupCreaturesPanel();
    }

    protected setupCreaturesPanel() {

        let reversedNonTemporalCreaturesList = CreatureUtils.findNonTemporalCreatures(CreatureUtils.sortCreaturesAscending(this.creatures));

        this.destroyNavPanel();

        this.navPanel = new MiniCreaturesPanel(this.scene!, this.canvas!, 300, this.creatureNavPanelY, (creature: Creature) => {
            this.creatureIndex = this.creatures.indexOf(creature);
            this.makeCharacterImage(creature);
            this.setupSlots(creature);
            BasePanel.closeAll();
            this.prepareCreatureStats(creature);
        }, reversedNonTemporalCreaturesList, this.creatureIndex!);
        this.scene!.add.existing(this.navPanel.getGameObject());

        let nonTemporalCreaturesList = CreatureUtils.findNonTemporalCreatures(CreatureUtils.sortCreaturesDescending(this.creatures));
        const creature: Creature = nonTemporalCreaturesList[this.creatureIndex!];
        this.makeCharacterImage(creature);
        this.setupSlots(creature);

        this.prepareCreatureStats(nonTemporalCreaturesList[this.creatureIndex!]);
    }

    protected async setupSlots(creature: Creature) {

        this.destroySLots();

        let slotsCount = creature.slotsCount;
        for (let num = 0; num < Sizes.MAX_ARTIFACT_SLOTS_COUNT; ++num) {
            let artifacts: Artifact[] = Object.assign([], creature.artifacts).sort((a: Artifact, b: Artifact) => {
                return a.id - b.id;
            });
            let art = artifacts[num];
            let unlockState = EnemyCreatureService.getUnlockState(slotsCount, artifacts.length, num);
            let artifactSlot = new ArtifactSlot(this.scene!, this.getSlotPositionX(num),
                this.getSlotPositionY(num), this.SLOT_SIZE_INNER, art, false, unlockState, () => undefined);
            this.centralContainer!.add(artifactSlot);
            this.artifactSlots.push(artifactSlot);
        }

    }

}
